import { normalizeHigieneOralSimplificada, syncHosLegacyFields } from '../data/higieneOralSimplificada';
import { normalizeIndicadorColValue } from '../data/indicadoresSaludBucalCols';
import {
  CPO_CEO_FILAS,
  normalizeIndiceCpoCeoInput,
  recalcularTodosLosTotalesCpoCeo,
} from '../data/indicesCpoCeo';

/**
 * Normaliza indicadores MSP antes de persistir (H.O.S., × en columnas, CPO-ceo).
 * La «×» en pantalla corresponde a valores en el paciente (ej. enfermedadPeriodontal: "leve").
 */
export function normalizeMspIndicadoresPayload(form) {
  const merged = { ...form };
  const hos = normalizeHigieneOralSimplificada(merged);
  const legacyHos = syncHosLegacyFields(hos);
  merged.higieneOralSimplificada = hos;
  merged.placa = legacyHos.placa ?? merged.placa ?? '';
  merged.calculo = legacyHos.calculo ?? merged.calculo ?? '';
  merged.gingivitis = legacyHos.gingivitis ?? merged.gingivitis ?? '';
  merged.enfermedadPeriodontal = normalizeIndicadorColValue(
    'enfermedadPeriodontal',
    merged.enfermedadPeriodontal,
  );
  merged.angleClasificacion = normalizeIndicadorColValue(
    'angleClasificacion',
    merged.angleClasificacion,
  );
  merged.fluorosis = normalizeIndicadorColValue('fluorosis', merged.fluorosis);
  const withTotals = recalcularTodosLosTotalesCpoCeo(merged);
  CPO_CEO_FILAS.forEach((fila) => {
    fila.cols.forEach((col) => {
      withTotals[col.key] = normalizeIndiceCpoCeoInput(withTotals[col.key]);
    });
  });
  return recalcularTodosLosTotalesCpoCeo(withTotals);
}
